import clsx from 'clsx';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { ValueTypeSelector, ValueTypeSelectorValue } from 'components/UI/V3/Forms/ValueTypeSelector';
import { FunctionComponent, useCallback } from 'react';
import styles from './DepositCategoryRow.module.scss';
import { DepositCategoryId } from './types';

export interface DepositCategoryRowProps {
    id: DepositCategoryId;
    label: string;
    checked: boolean;
    value: ValueTypeSelectorValue;
    className?: string;
    onCheckedChange: (id: DepositCategoryId, checked: boolean) => void;
    onValueChange: (id: DepositCategoryId, value: ValueTypeSelectorValue) => void;
}

export const DepositCategoryRow: FunctionComponent<DepositCategoryRowProps> = ({
    id,
    label,
    checked,
    value,
    className,
    onCheckedChange,
    onValueChange
}) => {
    const checkedHandler = useCallback((isChecked: boolean) => onCheckedChange(id, isChecked), [id, onCheckedChange]);

    const valueHandler = useCallback(
        (newValue: ValueTypeSelectorValue) => onValueChange(id, newValue),
        [id, onValueChange]
    );

    return (
        <div className={clsx(styles.row, className)}>
            <Checkbox
                className={styles.checkbox}
                label={label}
                checked={checked}
                onChange={checkedHandler}
            />
            <div
                className={clsx(styles.valueWrapper, { [styles.valueWrapperVisible]: checked })}
                aria-hidden={!checked}
            >
                <ValueTypeSelector
                    id={`deposit-${id}`}
                    value={value}
                    placeholder="$10"
                    disabled={!checked}
                    onChange={valueHandler}
                />
            </div>
        </div>
    );
};

export default DepositCategoryRow;
